import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const FloatingAssistantButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isVisible = useMemo(() => {
    const hiddenRoutes = ['/', '/login', '/register', '/assistant'];
    return !hiddenRoutes.includes(location.pathname);
  }, [location.pathname]);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate('/assistant')}
      className="fixed z-40 bottom-6 right-6 h-14 w-14 rounded-full bg-gradient-to-br from-primary via-primary/80 to-accent shadow-lg shadow-primary/30 hover:shadow-primary/50 transition hover:scale-105 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/40"
      aria-label="Open AI assistant"
    >
      <span className="absolute inset-0 rounded-full bg-primary/20 blur-xl opacity-70 animate-pulse" aria-hidden />
      <span className="relative flex h-full w-full items-center justify-center text-primary-foreground">
        <Icon name="Sparkles" size={24} />
      </span>
    </button>
  );
};

export default FloatingAssistantButton;
